/**
 * @module builder
 */
import type { OptionsDocument, QuoteDocument } from 'paintscout'

import differenceBy from 'lodash/differenceBy'
import { calculateQuote } from '../util/calculate/calculate-quote'
import { generateAreaDescription } from '../util/generate-area-description/generate-area-description'
import type { UpdateableAreaSubstrate } from '../index'

export function reorderAreaSubstrates(args: {
  quote: QuoteDocument
  options: OptionsDocument
  areaKey: string
  areaSubstrates: UpdateableAreaSubstrate[]
}): QuoteDocument {
  const { quote, options, areaKey, areaSubstrates } = args

  const orderItems = areaSubstrates.map((item) => {
    return {
      type: item.type,
      key: item.key
    }
  })

  const otherItems = differenceBy(quote.areas[areaKey].substrateOrder, orderItems, 'key')

  const updatedQuote = {
    ...quote,
    areas: {
      ...quote.areas,
      [areaKey]: {
        ...quote.areas[areaKey],
        substrateOrder: [...orderItems, ...otherItems],
        substrate_string: {
          ...quote.areas[areaKey].substrate_string
        }
      }
    }
  }

  updatedQuote.areas[areaKey].substrate_string.default = generateAreaDescription({
    quote: updatedQuote,
    options,
    areaKey
  })

  return calculateQuote({ quote: updatedQuote, options })
}

/*
 area.substrate_string: {
    use_custom?: boolean
    value?: string
    custom?: string
    default?: string
  }
 */
